import { jsx as _jsx } from "react/jsx-runtime";
import { ApolloProvider } from '@apollo/client';
import amplitude from 'amplitude-js';
import React, { Component } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import smartlookClient from 'smartlook-client';
import apolloClient from './actions/ApolloClient';
import { AwsRumContext } from './components/RumContext';
import { AMPLITUDE_KEY, SMARTLOOK_KEY } from './constants/env';
import ApiV2ModelContext from './contexts/ApiV2ModelContext';
import LoggerContext from './contexts/LoggerContext';
import AwsRumFactory from './factories/AwsRumFactory';
import LoggerFactory from './factories/LoggerFactory';
import i18n from './locales';
import ApiV2Model from './model/ApiV2Model';
import RootRouter from './router/RootRouter';
import store, { history } from './store/store';
import { getScheme, setScheme } from './utils/colorScheme';
import smartlookMockClient from './utils/smartlookMock';
const awsRum = AwsRumFactory.createInstance();
const apiV2Model = new ApiV2Model(apolloClient);
// @todo: Control log level from data attribute differently on various environments
const logger = LoggerFactory.createInstance(0);
if (SMARTLOOK_KEY) {
    smartlookClient.init(SMARTLOOK_KEY);
}
else {
    smartlookMockClient.init();
}
export default class App extends Component {
    render() {
        if (!window.location.hash.split('&').includes('noTrack') &&
            !window.location.hash.split('&').includes('#noTrack') &&
            !sessionStorage.getItem('noTrack')) {
            if (AMPLITUDE_KEY) {
                amplitude.getInstance().init(AMPLITUDE_KEY);
            }
        }
        if (getScheme() !== 'auto') {
            setScheme(getScheme());
        }
        // @ts-expect-error TS2769: No overload matches this call.
        const router = _jsx(RootRouter, { ...this.props, history: history });
        return _jsx(ApolloProvider, { client: apolloClient, children: _jsx(LoggerContext.Provider, { value: logger, children: _jsx(ApiV2ModelContext.Provider, { value: apiV2Model, children: _jsx(ReduxProvider, { store: store, children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(AwsRumContext.Provider, { value: awsRum, children: router }) }) }) }) }) });
    }
    componentDidCatch(error) {
        console.error(error);
        awsRum.recordError(error);
    }
}
